import BaseUseCase from "../../../base_use_case.js";

class SaveDeveloperUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/projects/developers/${identifier}` : `/api/v1/admin/projects/developers`;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: this.wrapParams(params, "developer"),
    });
  }
}

const instance = new SaveDeveloperUseCase();
export default instance;